import config from '~/config';

export const linkUnderlineClasses = config.underlineLinks
	? 'underline hover:no-underline'
	: 'no-underline hover:underline';
